//@prepros-prepend _helpers.js
//@prepros-prepend _site-icons.js
//@prepros-prepend modules/__utils.js
//@prepros-prepend modules/_accessibility.js
//@prepros-prepend modules/_accordions.js
//@prepros-prepend modules/_ambassadorprofiles.js
//@prepros-prepend modules/_bordermagic.js
//@prepros-prepend modules/_clicktofocus.js
//@prepros-prepend modules/_eventstagesline.js
//@prepros-prepend modules/_filterformatter.js
//@prepros-prepend modules/_filterui.js
//@prepros-prepend modules/_flipimgbg.js
//@prepros-prepend modules/_floatinglabels.js
//@prepros-prepend modules/_heroimages.js
//@prepros-prepend modules/_herovideo.js
//@prepros-prepend modules/_icon.js
//@prepros-prepend modules/_imagetextswitcher.js
//@prepros-prepend modules/_nav.js
//@prepros-prepend modules/_slickcarousel.js
//@prepros-prepend modules/_smoothscroll.js
//@prepros-prepend modules/_tabs.js
//@prepros-prepend modules/_tiledgallery.js
//@prepros-prepend modules/_toggle.js
//@prepros-prepend modules/_videolightbox.js

/*------------------------------------*\
 CENTRAL APP MASTER
 
 This file includes the module placeholders system that allows modular
 binding of custom methods / plugins etc.
 
 EXAMPLE
 
 <div data-module="example1,example2"></div>
 
 The above would meet two conditions in the below switch statement.
 
 \*------------------------------------*/
var app = (function ( $ ) {
	
	// This method will run when the DOM is ready.
	var init = function () {
		
		// Find any module placeholders
		var modulePlaceholders = $( "[data-module]" );
		
		if ( modulePlaceholders.any() ) {
			
			// Loop each placeholder
			modulePlaceholders.each( function () {
				
				var elem = $( this ),
					modules = elem.attr( "data-module" );
				
				// If any modules found
				if ( modules ) {
					
					// Split on the comma
					modules = modules.split( "," );
					
					// Loop each module key
					$.each( modules, function ( i, module ) {
						
						// Run switch to bind each module to each key
						switch ( module ) {
							
							case "nav":
								
								elem.nav();
								break;
							
							case "toggle":
								
								elem.toggle();
								break;
							
							case "accessibility":
								
								elem.accessibility();
								break;
							
							
							case "slickcarousel":
								elem.slickcarousel();
								break;
							
							case "accordions":
								elem.accordions();
								break;
							
							
							case "tabs":
								elem.tabs();
								break;
							
							case "herovideo":
								elem.herovideo();
								break;
							
							case "filter-formatter":
								elem.filterformatter();
								break;
							
							case "filter-ui":
								elem.filterui();
								break;
							
							case "tiledgallery":
								elem.tiledgallery();
								break;
							
							case "flipimgbg":
								elem.flipimgbg();
								break;
							
							
							case "smoothscroll":
								elem.smoothscroll();
								break;
							
							case "clicktofocus":
								elem.clicktofocus();
								break;
							
							
							case "eventstagesline":
								elem.eventstagesline();
								break;
							
							case "image-text-switcher":
								elem.imagetextswitcher();
								break;
						}
						
					} );
				}
			} );
		}
		
		// Run the icons module if it exists and there are site icons
		if ( typeof(site_icons) != 'undefined' ) {
			
			var targets = $( '[data-icon]' );
			
			if ( targets.any() ) {
				targets.each( function () {
					$( this ).icon();
				} );
			}
		}
		
		$( 'body' ).bordermagic();
		
		$( 'body' ).ambassadorProfiles();
		
		$( 'body' ).floatingLabels();
		
		
		// Polyfill for position sticky by Filament Group
		// https://github.com/filamentgroup/fixed-sticky
		FixedSticky.tests.sticky = false; // forcing it for everyone
		$( '.fixedsticky' ).fixedsticky();
		
		$( 'body' ).navs();
		$( 'body' ).videolightbox();
		
		$( '.hero--sized-by-image' ).each( function () {
			$( this ).heroImages();
		} );
	};
	
	return {
		init : init
	}
	
}( window.$ ));

// RUN!!
app.init();
